import { render, staticRenderFns } from "./insuranceSetupList.vue?vue&type=template&id=65abf2d6&"
import script from "./insuranceSetupList.vue?vue&type=script&lang=js&"
export * from "./insuranceSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports